import React from 'react';

const CompareCard = (props) => {
  const ref = props.compkpi === '' ? 1 : 0;
  let evol = 0;

  if (ref === 0) {
    evol = props.compkpi - props.refkpi;
  }

  const toneClass = props.color === '#d7f5df'
    ? 'kpi-card--up'
    : props.color === '#fadede'
      ? 'kpi-card--down'
      : '';

  const formatMain = (value) => {
    if (props.name === 'veh') return value.toFixed(0);
    if (['hours', 'kms', 'trips', 'otp'].includes(props.name)) return value.toFixed(1) + '%';
    return value.toFixed(1);
  };

  const formatDelta = () => {
    if (props.name === 'veh') return `${evol > 0 ? '+' : ''}${evol.toFixed(0)}`;
    if (['hours', 'kms', 'trips', 'otp'].includes(props.name)) {
      return `${evol > 0 ? '+' : ''}${evol.toFixed(1)}%`;
    }
    return `${evol > 0 ? '+' : ''}${evol.toFixed(1)}`;
  };

  const displayValue = ref === 0
    ? `${formatMain(props.compkpi)} (${formatDelta()})`
    : formatMain(props.refkpi);

  const showDetail = ['hours', 'kms', 'trips'].includes(props.name);

  return (
    <div className="compare-card-slot">
      <div className={`kpi-card h-100 ${toneClass}`}>
        <div className="kpi-card__body">
          <div className="kpi-card__value">{displayValue}</div>
          {showDetail ? (
            <div className="kpi-card__detail kpi-card__detail--placeholder">
              {props.actual.toLocaleString('fr-CA')} / {props.planned.toLocaleString('fr-CA')}
            </div>
          ) : (
            <div className="kpi-card__detail kpi-card__detail--placeholder" aria-hidden="true">&nbsp;</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompareCard;
